import { StyledCardContainer } from "pages/OrderUpdate/components/Update/styled";
import { IAccount } from "types/Account/Account";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

import { InsuranceName } from "./InsuranceName";
import { PatientInfo } from "./PatientInfo";
import { ProviderName } from "./ProviderName";
import { TotalAmount } from "./TotalAmount";
import { VisitInfo } from "./VisitInfo";

interface IDirectCreateProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
  isInternalUser: boolean;
  account?: IAccount | null;
}

export function DirectCreate({
  linkConfig,
  isInternalUser,
  account,
}: IDirectCreateProps) {
  return (
    <StyledCardContainer className="mb-3">
      <PatientInfo linkConfig={linkConfig} />
      <div className="formgrid grid w-100">
        <VisitInfo
          linkConfig={linkConfig}
          isInternalUser={isInternalUser}
          account={account}
        />
        <ProviderName linkConfig={linkConfig} />
        <InsuranceName linkConfig={linkConfig} />
        <TotalAmount linkConfig={linkConfig} />
      </div>
    </StyledCardContainer>
  );
}
